<template>
    <v-container>
        <v-data-table
            :headers="headers"
            :items="desserts"
            :items-per-page="10"
            class="elevation-1"
        >
            <template v-slot:top>
                <v-col cols="4">
                    <v-select label="กลุ่มงานบริการ" :items="groups">
                </v-select>
                </v-col>
            </template>
           
        </v-data-table>
    </v-container>
  
</template>

<script>
export default {
    name: "Data2_3",
    data: () => ({
        groups: ["กลุ่มงาน A"],
        headers: [
            {text: 'วัน', value: 'day'},
            {text: 'วันที่', value: 'date'},
            {text: 'ไม่มา', value: 'notComing'},
            {text: 'แจ้งยกเลิกนัด', value: 'cancel'}
            ],
        desserts: [
            {'day': 'จันทร์', 'date': '01/03/2021', 'notComing': 24, 'cancel': 6},
            {'day': 'อังคาร', 'date': '02/03/2021', 'notComing': 16, 'cancel': 9},
            {'day': 'พุธ', 'date': '03/03/2021',  'notComing': 11, 'cancel': 11},
            {'day': 'พฤหัส', 'date': '04/03/2021', 'notComing': 25, 'cancel': 17},
            {'day': 'ศุกร์', 'date': '05/03/2021', 'notComing': 10, 'cancel': 15},
            {'day': 'เสาร์', 'date': '06/03/2021', 'notComing': 8, 'cancel': 10},
            {'day': 'อาทิตย์', 'date': '07/03/2021', 'notComing': 14, 'cancel': 2}
        ]
    })
}
</script>